<template functional>
  <div class="b2b-chip"
  :class="{
    [data.staticClass]: !!data.staticClass,
    [data.class]: !!data.class,
    'b2b-chip--colored': props.colored,
    'b2b-chip--primary': props.primary,
    'b2b-chip--small': props.small,
  }"
  :style="{
    width: injections.methods.toSizeValue(props.width),
    maxWidth: injections.methods.toSizeValue(props.maxWidth),
    minWidth: injections.methods.toSizeValue(props.minWidth),
    background: props.background,
    color: props.color,
  }">
    <slot>{{ data.domProps && data.domProps.textContent }}</slot>

    <span
      v-if="listeners['click:close']"
      class="b2b-chip__close"
      @click.stop="listeners['click:close']($event)"
    >
      <component :is="injections.components.XIcon" />
    </span>
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons';

import { toSizeValue } from '../../utils/css-variables';

export default {
  name: 'b2b-chip',

  props: {
    primary: Boolean,
    colored: Boolean,
    background: String,
    color: String,
    small: Boolean,
    width: [Number, String],
    maxWidth: [Number, String],
    minWidth: [Number, String],
  },

  inject: {
    methods: {
      default: {
        toSizeValue,
      },
    },

    components: {
      default: {
        XIcon,
      },
    },
  },
};
</script>

<style lang="scss">
.b2b-chip {
  margin: 8px;
  height: 32px;
  padding: 0 14px;
  display: inline-block;

  color: $colorMainPrimary;

  border-radius: 16px;
  border: 1px solid $colorMainPrimary;

  align-items: center;
  display: inline-flex;

  cursor: default;

  &__close {
    cursor: pointer;
    margin-left: 8px;
    height: 24px;
  }

  &--primary {
    color: var(--main-color--primary);
    border: 1px solid var(--main-color--primary);
  }

  &--colored {
    color: $colorMainPrimaryContent;
    background-color: $colorMainPrimary;
  }

  &--colored#{&}--primary {
    color: var(--main-color--primary-text);
    background-color: var(--main-color--primary);
  }

  &--small {
    height: 24px;
    padding: 0 8px;
  }
}

.b2b-chip.b2b-chip--colored.b2b-chip--primary {
  font-size: 14px;
}

@media screen and (min-width: 1921px) {
  .b2b-chip {
    padding: 0 5px !important;
  }

  .b2b-chip.b2b-chip--colored.b2b-chip--primary {
    font-size: 12px !important;
  }
}
</style>
